import $ from 'jquery';
import { storeSetting, loadSetting } from './common';

let searchDisplayLO = null;
let originalCreative = null;
let initialized = false;

const element = `
  <div class=display-office>
    <h4 class=display-office__label>Display Listing Office</h4>
    <div class=display-office__container>
      <div class=display-office__all>
        <input id=showOfficeAll type=radio name=display-office>
        <label for=showOfficeAll>On All</label>
      </div>
      <div class=display-office__first>
        <input id=showOfficeFirst type=radio name=display-office>
        <label for=showOfficeFirst>First Image Only</label>
      </div>
      <div class=display-office__none>
        <input id=showOfficeNone type=radio name=display-office>
        <label for=showOfficeNone>No</label>
      </div>
    </div>
  </div>
`;

export function displayOffice($parent) {
  if (initialized) return;
  const $dom = $(element);
  originalCreative = $('.creative-item__second-sub').val();
  $parent.append($dom);
  loadSetting('searchDisplayLO')
    .then((r) => {
      if (r === '' || r === 'none') {
        setPropDisplayLO($dom, 'none');
      } else if (r === 'first') {
        setPropDisplayLO($dom, 'first');
      } else if (r === 'all') {
        setPropDisplayLO($dom, 'all');
      }
    })
    .catch(() => window.onbeforeunload && alert('Could not load display office setting'));

  $dom.find('#showOfficeAll').on('change', () => {
    if (searchDisplayLO === 'all' || searchDisplayLO === 'none') {
      originalCreative = $('.creative-item__second-sub').val();
    }
    setPropDisplayLO($dom, 'all');
  });
  $dom.find('#showOfficeFirst').on('change', () => {
    setPropDisplayLO($dom, 'first');
  });
  $dom.find('#showOfficeNone').on('change', () => {
    setPropDisplayLO($dom, 'none');
  });
  initialized = true;
}

export function checkDisplayLO(prop) {
  if (searchDisplayLO === 'first') {
    if (prop.order === 1) { prop.creative_lines[1] = prop.listing_office; }
  }
}

function setPropDisplayLO($dom, v) {
  storeSetting('searchDisplayLO', v)
    .then(() => {
      if (v === 'all') {
        $dom.find('#showOfficeAll').attr('checked', 'checked');
        $('.creative-item__second-sub')
          .val('[listing_office]')
          .addClass('display-office-all')
          .trigger('keyup');
      } else if (v === 'first') {
        $dom.find('#showOfficeFirst').attr('checked', 'checked');
        $('.creative-item__second-sub')
          .val(originalCreative)
          .removeClass('display-office-all')
          .trigger('keyup');
      } else if (v === 'none') {
        $dom.find('#showOfficeNone').attr('checked', 'checked');
        $('.creative-item__second-sub')
          .val(originalCreative)
          .removeClass('display-office-all')
          .trigger('keyup');
      }
      searchDisplayLO = v;
    })
    .catch(() => alert('Could not save display office setting'));
}
